// extracted by mini-css-extract-plugin
module.exports = {"root":"PlasmicTableTd_root__Tzgdp","text___5NnZu":"PlasmicTableTd_text___5NnZu__Qnwqv"};